// import React from "react";
// import { FaMapMarkedAlt, FaCity, FaRoute, FaGlobeAsia } from "react-icons/fa";

// const OurNetwork = () => {
//   return (

// <>


    
// <section className="gauto-breadcromb-area section_70">
//         <div className="container">
//           <h3 className="text-center text-white">Career</h3>
//         </div>
//       </section>
//     <section className="network-section">
//       <div className="network-container">

//         {/* Header */}
//         <div className="network-header">
//           <h2>
//             Our <span>Network</span>
//           </h2>
//           <p>
//             Shambhu Cabs operates across major cities and routes, offering
//             reliable and comfortable cab services across India.
//           </p>
//         </div>

//         {/* Network Cards */}
//         <div className="network-grid">

//           {/* Mumbai Outstations */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaCity />
//             </div>
//             <h4>Mumbai Outstations</h4>
//             <p>
//               Comfortable outstation cab services from Mumbai to nearby and
//               long-distance destinations.
//             </p>
//           </div>

//           {/* Mumbai - Pune */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaRoute />
//             </div>
//             <h4>Mumbai ⇄ Pune ⇄ Mumbai</h4>
//             <p>
//               Daily cab services between Mumbai and Pune with experienced
//               drivers and well-maintained vehicles.
//             </p>
//           </div>

//           {/* Pune */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaCity />
//             </div>
//             <h4>Pune</h4>
//             <p>
//               Local and outstation cab services across Pune with timely pickups
//               and smooth travel experience.
//             </p>
//           </div>

//           {/* Nashik */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaMapMarkedAlt />
//             </div>
//             <h4>Nashik</h4>
//             <p>
//               Reliable cab services for Nashik including temple visits,
//               vineyard tours, and business travel.
//             </p>
//           </div>

//           {/* Kolhapur */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaMapMarkedAlt />
//             </div>
//             <h4>Kolhapur</h4>
//             <p>
//               Safe and comfortable cab connectivity for Kolhapur and nearby
//               destinations.
//             </p>
//           </div>

//           {/* Goa */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaGlobeAsia />
//             </div>
//             <h4>Goa</h4>
//             <p>
//               Enjoy hassle-free long-distance cab services to Goa with premium
//               vehicles and professional drivers.
//             </p>
//           </div>

//           {/* Sambhaji Nagar */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaCity />
//             </div>
//             <h4>Sambhaji Nagar (Aurangabad)</h4>
//             <p>
//               Cab services for Sambhaji Nagar including tourist and business
//               travel requirements.
//             </p>
//           </div>

//           {/* Pan India */}
//           <div className="network-card highlight">
//             <div className="network-icon">
//               <FaGlobeAsia />
//             </div>
//             <h4>Mumbai to Pan-India</h4>
//             <p>
//               Nationwide cab services from Mumbai to all major cities across
//               India with reliable fleet coverage.
//             </p>
//           </div>

//         </div>

//       </div>
//     </section>
// </>
//   );
// };

// export default OurNetwork;


import React from "react";
import { FaMapMarkedAlt, FaCity, FaGlobeAsia } from "react-icons/fa";

const OurNetwork = () => {
  return (
    <>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  Sanavi Travels Network
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="network-section">
        <div className="network-container">
          <div className="network-grid">
            {/* Mumbai Outstations */}
            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Mumbai Outstations</h4>
              <p>
                Sanavi Travels offers reliable and comfortable outstation cab
                services from Mumbai to nearby and long-distance destinations.
              </p>
            </div>

            {/* Pune */}
            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Pune</h4>
              <p>
                Trusted local and outstation cab services in Pune with Sanavi
                Travels, ensuring punctual pickups and smooth journeys.
              </p>
            </div>

            {/* Nashik */}
            <div className="network-card">
              <div className="network-icon">
                <FaMapMarkedAlt />
              </div>
              <h4>Nashik</h4>
              <p>
                Sanavi Travels provides dependable cab services in Nashik for
                temple visits, vineyard tours, and business travel.
              </p>
            </div>

            {/* Kolhapur */}
            <div className="network-card">
              <div className="network-icon">
                <FaMapMarkedAlt />
              </div>
              <h4>Kolhapur</h4>
              <p>
                Safe and comfortable cab connectivity in Kolhapur with Sanavi
                Travels for city and nearby travel.
              </p>
            </div>

            {/* Goa */}
            <div className="network-card">
              <div className="network-icon">
                <FaGlobeAsia />
              </div>
              <h4>Goa</h4>
              <p>
                Travel to Goa stress-free with Sanavi Travels’ premium
                long-distance cab services and experienced drivers.
              </p>
            </div>

            {/* Sambhaji Nagar */}
            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Sambhaji Nagar (Aurangabad)</h4>
              <p>
                Sanavi Travels offers efficient cab services in Sambhaji Nagar
                for tourism, corporate, and personal travel needs.
              </p>
            </div>

            {/* Shirdi */}
            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Shirdi</h4>
              <p>
                Comfortable and convenient cab services to Shirdi by Sanavi
                Travels, ideal for pilgrims and family travelers.
              </p>
            </div>

            {/* Solapur */}
            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Solapur</h4>
              <p>
                Sanavi Travels ensures safe, timely, and affordable cab services
                across Solapur and surrounding regions.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurNetwork;
